// extracted by mini-css-extract-plugin
export default {"icon":"InspectionList_icon__Jsw8t"};